const Confirm = ({msg, setMsg, buttons}) => {
  
  const handleClose = ev => {
    setMsg({});
  }
  
  if (!msg) return null;
  const sp = msg.split('|');
  return(
    <div className="modal fade show" style={{display:"block",backgroundColor: "rgba(0,0,0,0.5)"}}>
      <div className="modal-dialog modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            {sp[1]!==undefined?<h2>{sp[0]}</h2>:<p style={{whiteSpace: 'pre-wrap'}}>{sp[0]}</p>}
            <button type="button" className="btn-close" onClick={handleClose}></button>
          </div>
    {sp[1] &&
          <div className="modal-body" style={{whiteSpace: 'pre-wrap'}}>
            {sp[1]}
          </div>
    }
          <div className="modal-footer">
  {buttons.map(bu=>(
            <button type="button" className={"btn btn-"+(bu.typ?bu.typ:'secondary')} data-bs-dismiss="modal" onClick={bu.action?bu.action:handleClose}>{bu.text}</button>
  ))}          
          </div>
        </div>
      </div>
    </div>
  )
}
export default Confirm;